import dayjs from 'dayjs';
import { ApiEndpointClient } from './resource-client';
export class OrderOverviewsClient extends ApiEndpointClient {
    constructor(http) {
        super(http, 'valuation-frontend');
    }
    getAppraiserOrderOverview = async ({ orderId }) => {
        return this.get(`/orders-overview/${orderId}`, { response: 'content-type-or-empty' });
    };
    getAppraiserOrderOverviews = async ({ customerId }) => {
        return this.get('/orders-overview/', {
            response: 'content-type-or-empty',
            query: customerId ? { customer_uuid: customerId } : {},
        });
    };
    getClientPortalOrderOverview = async ({ orderId, customerId }, options) => {
        return this.get(`/orders-overview/${orderId}`, {
            response: 'content-type',
            query: customerId ? { customer_uuid: customerId } : {},
            signal: options?.signal,
        });
    };
    getClientPortalOrderOverviews = async ({ customerId, statuses, assignedCustomers, titleFilter, valuationDateRange, portfolioId, } = {}, options) => {
        const joinedStatuses = statuses?.join(',');
        const joinedAssignedCustomers = assignedCustomers?.join(',');
        return this.get('/orders-overview/', {
            response: 'content-type',
            query: {
                ...(joinedStatuses ? { status_search: joinedStatuses } : {}),
                ...(joinedAssignedCustomers ? { assigned_customer_users: joinedAssignedCustomers } : {}),
                ...(titleFilter ? { search_string: titleFilter } : {}),
                ...(valuationDateRange?.start ? { valuation_date_start: dayjs(valuationDateRange.start).format('YYYY-MM-DD') } : {}),
                ...(valuationDateRange?.end ? { valuation_date_end: dayjs(valuationDateRange.end).format('YYYY-MM-DD') } : {}),
                ...(portfolioId !== undefined ? { portfolio_uuid: portfolioId } : {}),
                ...(customerId ? { customer_uuid: customerId } : {}),
            },
            signal: options?.signal,
        });
    };
}
